const { MONTHS } = require('../consts')

/**
 * Visszaadja a `month` indexhez tartozó hónap nevet.
 * @param {number} monthIndex - A hónap indexe.
 * @returns {string} A megfelelő hónap neve.
 */
module.exports.getMonthName = function getMonthName (monthIndex) {
  return MONTHS[monthIndex] || 'December'
}
